import { render, staticRenderFns } from "./SideBySideComments.vue?vue&type=template&id=50846884"
import script from "./SideBySideComments.vue?vue&type=script&lang=js"
export * from "./SideBySideComments.vue?vue&type=script&lang=js"
import style0 from "./SideBySideComments.vue?vue&type=style&index=0&id=50846884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports